<template>
	<button
		:href="href"
		class="ecommerce-storage-selector-item"
		:class="{ active }"
		:disabled="disabled"
	>
		<svg
			v-if="disabled && !active"
			class="rectangle"
			width="100"
			height="5"
		>
			<rect
				width="100"
				height="1"
				style="fill: rgb(206 207 212)"
			/>
		</svg>
		<slot></slot>
	</button>
</template>

<script>
export default defineNuxtComponent({
	name: "ECommerceStorageSelectorItem",

	props: {
		active: {
			type: Boolean,
		},
		href: {
			type: String,
			default: "javascript:",
		},
		disabled: {
			type: Boolean,
			default: true,
		},
	},
});
</script>

<style lang="scss" scoped>
.ecommerce-storage-selector-item {
	padding: $spacing-m $spacing-l;
	border-radius: 35px;
	border: 1px solid $color-neutrals-200-tint;
	text-decoration: none;
	color: $color-neutrals-black;
	transition: border-color 0.2s ease;
	box-shadow: 0 0 0 1px transparent;
	background: none;
	position: relative;
	overflow: hidden;
	cursor: pointer;

	&:hover,
	&:focus {
		&:not(.active) {
			&:not(:disabled) {
				border-color: $color-neutrals-600-shade;
			}
		}
	}

	.rectangle {
		position: absolute;
		top: 25px;
		left: 0;
		transform: rotate(20deg);
	}

	&.active {
		border-color: $color-information-500-core;
		font-weight: bold;
		box-shadow: 0 0 0 1px $color-information-500-core;
	}
}
</style>
